import { useEffect } from 'react';

import StatsCard from '../../../components/Cards/StartsCard';
import { Money } from '../../../components/Layout/PagePieces';
import useProfitOverview from '../../../hooks/dashboard/profit/useProfitOverview';
import { formatNaira } from '../../../utils/utils';

const money = (v?: string | number) => formatNaira(Number(v ?? 0));

// Four tiles for the overview grid (keeps it a multiple of four): profit
// today and this month with what made it up (limits spec P5).
const ProfitTiles = () => {
  const { overview, fetchOverview } = useProfitOverview();

  useEffect(() => {
    fetchOverview();
    // eslint-disable-next-line
  }, []);

  const today = overview?.today;
  const month = overview?.month;
  const costs = (r?: typeof today) => Number(r?.llm_cost ?? 0) + Number(r?.whatsapp_cost ?? 0) + Number(r?.paystack_fees ?? 0);

  return (
    <>
      <StatsCard.Root>
        <StatsCard.Header hint='What Hethera earned today minus every cost: Paystack fees, VTpass, Claude and WhatsApp. Red means a loss.'>Profit today</StatsCard.Header>
        <StatsCard.Value>
          <Money className={Number(today?.profit ?? 0) < 0 ? 'loss' : 'gain'}>{money(today?.profit)}</Money>
        </StatsCard.Value>
        <StatsCard.PlainFooter>
          Earned {money(today?.revenue)} · costs {money(costs(today))}
        </StatsCard.PlainFooter>
      </StatsCard.Root>
      <StatsCard.Root>
        <StatsCard.Header hint='The same as Profit today, for this calendar month so far.'>Profit this month</StatsCard.Header>
        <StatsCard.Value>
          <Money className={Number(month?.profit ?? 0) < 0 ? 'loss' : 'gain'}>{money(month?.profit)}</Money>
        </StatsCard.Value>
        <StatsCard.PlainFooter>
          Margin {money(month?.purchase_margin)} · service fees {money(month?.service_fees)}
        </StatsCard.PlainFooter>
      </StatsCard.Root>
      <StatsCard.Root>
        <StatsCard.Header hint='What the chat itself cost: the Claude AI that replies to customers, plus WhatsApp’s charges for messages.'>Claude &amp; WhatsApp this month</StatsCard.Header>
        <StatsCard.Value>{money(Number(month?.llm_cost ?? 0) + Number(month?.whatsapp_cost ?? 0))}</StatsCard.Value>
        <StatsCard.PlainFooter>
          Claude {money(month?.llm_cost)} · WhatsApp {money(month?.whatsapp_cost)}
        </StatsCard.PlainFooter>
      </StatsCard.Root>
      <StatsCard.Root>
        <StatsCard.Header hint='Card processing fees Paystack keeps on every charge. They aren’t returned when a purchase is refunded.'>Paystack fees this month</StatsCard.Header>
        <StatsCard.Value>{money(month?.paystack_fees)}</StatsCard.Value>
        <StatsCard.PlainFooter>Kept by Paystack, even on refunds</StatsCard.PlainFooter>
      </StatsCard.Root>
    </>
  );
};

export default ProfitTiles;
